const API_BASE = process.env.REACT_APP_SERVER_URL || 'http://localhost:3001';

export default API_BASE;

// The one Discord invite (permanent server invite). Every "join Discord" button uses it.
export const DISCORD_INVITE = 'https://discord.gg/SZMw4vpUJV';
